import * as React from 'react'
import { ReactElement } from 'react'
import { Formik, useFormikContext } from 'formik'
import {
    Button,
    Dialog,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
    DialogTrigger,
} from '@fluentui/react-components'
import { AddRegular, DeleteRegular, DismissRegular } from '@fluentui/react-icons'
import { DocketEntryAction } from './DocketEntryList'
import { DocketEntryDto, DocketProceedingDto } from './DocketProceedingForm'
import DocketEntryForm from './DocketEntryFormContainer'
import { DocketProceedingPanelProps } from './FormContainer'
import * as Yup from 'yup'

export type DocketEntryDialogProps = DocketProceedingPanelProps & {
    show: boolean
    setOpen: (open: boolean) => void
    initialValues: DocketEntryDto
    index: number
    action: DocketEntryAction
}

const ValidationSchema = Yup.object().shape({
    date: Yup.string().required('Datum is een verplicht veld'),
    title: Yup.string().required('Titel is een verplicht veld'),
})

export default function DocketEntryDialog(props: DocketEntryDialogProps): ReactElement {
    const { values, setFieldValue } = useFormikContext<DocketProceedingDto>()

    const removeItem = (cutIndex: number) => {
        setFieldValue(
            'entries',
            values.entries.filter((_, index) => index !== cutIndex),
        )
        props.setOpen(false)
    }

    const onDismiss = () => {
        if (props.action === DocketEntryAction.ADD) {
            setFieldValue('entries', values.entries.slice(1))
        }
        props.setOpen(false)
    }

    return (
        <Dialog open={props.show} onOpenChange={onDismiss}>
            <DialogSurface>
                <DialogBody>
                    <Formik<DocketEntryDto>
                        key={props.index}
                        validationSchema={ValidationSchema}
                        validateOnBlur={false}
                        validateOnChange={false}
                        validateOnMount={false}
                        initialValues={props.initialValues}
                        onSubmit={values => {
                            setFieldValue(`entries[${props.index}]`, values)
                            props.setOpen(false)
                        }}
                    >
                        {formik => (
                            <>
                                <DialogTitle>{`Handeling ${
                                    props.action === DocketEntryAction.EDIT ? 'aanpassen' : 'toevoegen'
                                }`}</DialogTitle>
                                <DialogContent>
                                    <DocketEntryForm {...props} />
                                </DialogContent>
                                <DialogActions>
                                    <DialogTrigger disableButtonEnhancement>
                                        <Button appearance="transparent" icon={<DismissRegular />} onClick={onDismiss}>
                                            Annuleren
                                        </Button>
                                    </DialogTrigger>
                                    <Button icon={<AddRegular />} appearance="primary" onClick={formik.submitForm}>
                                        {props.action === DocketEntryAction.EDIT ? 'Opslaan' : 'Toevoegen'}
                                    </Button>
                                    {props.action === DocketEntryAction.EDIT && (
                                        <Button
                                            appearance="transparent"
                                            icon={<DeleteRegular />}
                                            onClick={() => removeItem(props.index)}
                                        >
                                            Verwijderen
                                        </Button>
                                    )}
                                </DialogActions>
                            </>
                        )}
                    </Formik>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    )
}
